module.exports = __webpack_public_path__ + "img/team-2.37501f5c.png";